export default "__VITE_ASSET__DDx0lHD1__"